import { useEffect, useRef, useState } from 'react'

import { ClearSocketMessageHandler, ConnectWebSocketForScreen, DisconnectWebSocket, GetGenderMode, SetSocketMessageHandler } from './../../utilities/BL/Zones'

import { Questions } from './Sections/Questions'
import { Results } from './Sections/Results'
import { Wait } from './Sections/Wait'
import { Welcome } from './Sections/Welcome'
import { Colors } from './Sections/Colors'
import { Start } from './Sections/Start'
import { Thanks } from './Sections/Thanks'
import { Lottery } from './Sections/Lottery'
import { GoalScreen } from './Sections/GoalScreen'
import { GoalScreenV2 } from './Sections/GoalScreenV2'
import { GoalScreenV2_Caminadora } from './Sections/GoalScreenV2_Caminadora'
import { Versus } from './Sections/Goal/Versus'
import Balloons from './Sections/Balloons'
import { Riddle } from './Sections/Riddle'
import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
import { FrontPage } from './Sections/QuizzWithImageAndOptions/FrontPage'
import { FrontPage as RiddleFrontPage } from './Sections/Riddle/FrontPage'
import { Rojito as RojitoBrandFrontPage } from './Sections/Balloons/FrontPages/Brands/Rojito'
import { Rojito as RojitoBrandBalloons } from './Sections/Balloons/Brands/RojitoDrinks'
import { NoisemeterV2 } from './../Overlays/NoisemeterV2'
import { FrontPageNoisemeterV2 } from './../Overlays/Overlays/NoisemeterV2'
import { SelfieFan } from './Sections/SelfieFan'
import { QRSelfieFan } from './Sections/QRSelfieFan'
import { QRMessages } from './Sections/QRMessages'
import { SelfieFanIA } from './Sections/SelfieFanIA'
import { QRPluckingRooster } from './Sections/QRPluckingRooster'
import { RankingPluckingRooster } from './Sections/RankingPluckingRooster'
import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
import { LuchoFest } from './Sections/LuchoFest'
import { FrontPage as FrontPagePicnic } from './Sections/Picnic/FrontPagePicnic'
import { Picnic } from './Sections/Picnic'
import { FrontPageRunToGoal } from './Sections/Goal/FrontPageRunToGoal'
import { FrontPageRunToGoal as FrontPageRunToGoalDaikin } from './Sections/Goal/Brands/Daikin/FrontPageRunToGoal'
import { Tacos } from './Sections/Tacos'
import { FrontPageTacos } from './Sections/Tacos/FrontPageTacos'

import { SoupSimulator } from './Sections/Soup/Brands/SoupSimulator'
import { BriefcaseScreen } from './Sections/BriefcaseScreen'
import { FrontPageBriefcase } from './Sections/Briefcase/FrontPageBriefcase'

import { CatchTheBall } from './Sections/CatchTheBall'
import { SlotMachine } from './Sections/SlotMachine'

import { Voting } from './Sections/Voting'
import { FrontpageCaps } from './Sections/Caps/FrontpageCaps'
import { Caps } from './Sections/Caps'
import { Roulette } from './Sections/Roulette'
import { LightShow } from './Sections/LightShow'
import { CarreraContinuaGame, CarreraContinuaCover } from './Sections/CarreraContinua'
import { FightersCover, FightersGame } from './Sections/Fighters'
import { QuickReactionCover, QuickReactionGame } from './Sections/QuickReaction'
import { PlaylistScreen } from './Sections/PlaylistScreen'
import { FrontPageSequence } from './Sections/Sequence/FrontPageSequence'
import { SequenceScreen } from './Sections/SequenceScreen'
import { MemoryCover, MemoryGame } from './Sections/Memory'
import { TugOfWarCover, TugOfWarGame } from './Sections/TugOfWar'
import { SurferCover, SurferGame } from './Sections/Surfer'
import PersonalSurferOverlay from '../Overlays/PersonalSurferOverlay'


const Screen = ({ roomId: propRoomId, defaultView }) => {
    const [question, setQuestion] = useState(null)
    const [results, setResults] = useState(null)
    const [lottery, setLottery] = useState(null)
    const [connectionStatus, setConnectionStatus] = useState('idle')
    const [toastMessage, setToastMessage] = useState('')

    const [activeComponent, setActiveComponent] = useState(null)

    const [currentMatchId, setCurrentMatchId] = useState(null);
    const [phase, setPhase] = useState('idle');
    const [timing, setTiming] = useState({ startAt: null, endsAt: null });

    const [isActiveWomensMode, setIsActiveWomensMode] = useState(null)

    const countdownTimerRef = useRef(null)
    const [balloonsUI, setBalloonsUI] = useState({
        uiStatus: 'Idle',
        countdownUntil: null
    })

    const [tacoMatchState, setTacoMatchState] = useState(null);
    const [catchMatchState, setCatchMatchState] = useState(null);
    const [capsMatchState, setCapsMatchState] = useState(null);
    const [slotPayload, setSlotPayload] = useState(null)
    const [roulettePayload, setRoulettePayload] = useState(null)
    const [carreraMatchState, setCarreraMatchState] = useState(null)
    const [fightersMatchState, setFightersMatchState] = useState(null)
    const [quickReactionMatchState, setQuickReactionMatchState] = useState(null)
    const [sequencePayload, setSequencePayload] = useState(null)
    const [memoryMatchState, setMemoryMatchState] = useState(null)
    const [tugOfWarMatchState, setTugOfWarMatchState] = useState(null)
    const [surferMatchState, setSurferMatchState] = useState(null)
    const bootstrapConfigRef = useRef(null)

    
    const showToast = (msg) => {
        setToastMessage(msg)
        setTimeout(() => setToastMessage(''), 3000)
    }

    // // ENRUTADOR INTELIGENTE (Detecta si es V1 o V2)
    // const routeGoalByState = (state, matchData) => {
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         return (state === 'Running' || state === 'Finished') ? 5.2 : 5;
    //     }
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // // ENRUTADOR INTELIGENTE (Detecta si es V1 o V2)
    // const routeGoalByState = (state, matchData) => {
    //     // Verificamos si es V2
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         // Si está en espera, mostramos la Portada Animada (5.3)
    //         if (state === 'Waiting' || state === 'Idle') return 5.3;
    //         // Si está corriendo o finalizó, mostramos el juego y la animación de gol (5.2)
    //         return 5.2;
    //     }

    //     // Si no, es la V1 original (Se mantiene intacta)
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // // ENRUTADOR INTELIGENTE (A prueba de fallos)
    // const routeGoalByState = (state, matchData) => {
    //     // 1. Si el juego está en espera (recién entramos a la sección o reiniciamos),
    //     // SIEMPRE mostramos la Portada Animada Nueva, cortando de raíz cualquier error.
    //     if (state === 'Waiting' || state === 'Idle') {
    //         return 5.3;
    //     }

    //     // 2. Si el juego ya está corriendo o finalizó, verificamos si es V2
    //     if (matchData && matchData.elapsedMilliseconds !== undefined) {
    //         return 5.2; // Pantalla de Juego V2
    //     }

    //     // 3. Si no cumple lo anterior, nos vamos al juego V1 original
    //     return (state === 'Running' || state === 'Finished') ? 5.1 : 5;
    // }

    // ENRUTADOR ESTRICTO V2 (Ignoramos la V1 para evitar interferencias)
    const routeGoalByState = (state) => {
        // Todo lo que sea espera o inicio, va a la Portada Animada (5.3)
        if (state === 'Waiting' || state === 'Idle') return 5.3;
        // Todo lo demás (Running, Finished) va al Juego V2 (5.2)
        return 5.2;
    }

    const SetGoalAndRoute = (updater) => {
        try {
            setGoal(prev => {
                const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
                setActiveComponent(routeGoalByState(next.state, next))
                return next
            })
        } catch (error) { }
    }

    const [goal, setGoal] = useState({
        matchId: null,
        state: 'Waiting',
        progressLucho: 0,
        progressTunita: 0,
        tapsParaGanar: 100,
        winner: null,
        elapsedMilliseconds: 0,
        zonesProgress: []
    })

    const [balloons, setBalloons] = useState({
        matchId: null,
        status: 'Waiting',
        startAt: null,
        endsAt: null,
        target: 0,
        zones: [],
        winners: null
    })

    // ==========================================
    // ESTADO NUEVO: VAS O NO VAS (MALETINES)
    // ==========================================
    const [briefcaseState, setBriefcaseState] = useState({
        phase: 'WAITING',
        briefcases: [], // El backend nos mandará el arreglo de maletines
        suspenseBriefcaseId: null,
        revealData: null
    })

    const RouteBalloonsByStatus = (s, next) => {
        const hasCountdown = next?.startAt && new Date(next.startAt).getTime() > Date.now()
        if (s === 'Running' || s === 'Finished' || hasCountdown) return 10.1
        return 10
    }

    const SetBalloonsAndRoute = (updater) => {
        setBalloons(prev => {
            const next = typeof updater === 'function' ? updater(prev) : { ...prev, ...updater }
            setActiveComponent(RouteBalloonsByStatus(next.status, next))
            return next
        })
    }

    const forceUIStatus = (status) => {
        setBalloonsUI(prev => {
            const order = { Idle: 0, Countdown: 1, Running: 2, Finished: 3 };
            return order[status] >= order[prev.uiStatus]
                ? { ...prev, uiStatus: status }
                : prev;
        });
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const roomId = searchParams.get('roomId') || propRoomId;

        const triggerInitialLayout = (templateName, configData) => {
            const name = templateName?.toLowerCase();
            const mockMessage = {
                type: null,
                data: configData,
                payload: configData
            };

            switch (name) {
                case 'slotmachine':
                    mockMessage.type = 'slotmachine.prepare';
                    break;
                case 'roulette':
                    mockMessage.type = 'roulette.prepare';
                    break;
                case 'briefcase':
                case 'maletines':
                    mockMessage.type = 'briefcase.layout';
                    break;
                case 'tacos':
                    mockMessage.type = 'taco.layout';
                    break;
                case 'caps':
                    mockMessage.type = 'caps.layout';
                    break;
                case 'catchtheball':
                    mockMessage.type = 'catchtheball';
                    break;
                case 'trivia':
                case 'quizz':
                    mockMessage.type = 'quizzwithimageandoptions';
                    break;
                case 'balloons':
                case 'balloons':
                case 'globos':
                    mockMessage.type = 'ballons';
                    break;
                case 'carreracontinua':
                    mockMessage.type = 'carreracontinua.created';
                    break;
                case 'riddle':
                case 'adivinanza':
                case 'adivina':
                    mockMessage.type = 'riddle';
                    break;
                case 'quickreaction':
                case 'quick_reaction':
                case 'quickreactiongame':
                case 'reaccionrapida':
                case 'reaccion_rapida':
                    mockMessage.type = 'quick_reaction_game_scene_shown';
                    break;
                case 'quickreactioncover':
                case 'quick_reaction_cover':
                case 'reaccionrapidacover':
                case 'reaccion_rapida_cover':
                    mockMessage.type = 'quick_reaction_cover_shown';
                    break;
                case 'playlist':
                case 'armalaplaylist':
                case 'armala_playlist':
                case 'arma_la_playlist':
                    mockMessage.type = 'playlist.layout';
                    break;
                case 'sequence':
                case 'secuencia':
                case 'simon':
                case 'sequencescreen':
                case 'sequence_screen':
                    mockMessage.type = 'sequence.layout';
                    break;
                case 'sequencecover':
                case 'sequence_cover':
                case 'sequencefrontpage':
                case 'sequence_frontpage':
                case 'frontpagesequence':
                    mockMessage.type = 'sequence.frontpage';
                    break;
                case 'memory':
                case 'memorama':
                case 'memorygame':
                case 'memory_game':
                case 'memoryscreen':
                case 'memory_screen':
                    mockMessage.type = 'memory_game_scene_shown';
                    break;
                case 'memorycover':
                case 'memory_cover':
                case 'memorama_cover':
                case 'memoramacover':
                case 'memoryfrontpage':
                case 'memory_frontpage':
                case 'frontpagememory':
                    mockMessage.type = 'memory_cover_shown';
                    break;
                case 'tugofwar':
                case 'tug_of_war':
                case 'tugofwargame':
                case 'tug_of_war_game':
                case 'estirayafloja':
                case 'estira_y_afloja':
                    mockMessage.type = 'tugofwar_game_scene_shown';
                    break;
                case 'tugofwarcover':
                case 'tug_of_war_cover':
                case 'tugofwar_cover':
                case 'estirayaflojacover':
                case 'estira_y_afloja_cover':
                    mockMessage.type = 'tugofwar_cover_shown';
                    break;
                case 'surfer':
                case 'esquivador':
                case 'surfergame':
                case 'surfer_game':
                case 'surferscreen':
                case 'surfer_screen':
                    mockMessage.type = 'surfer_game_scene_shown';
                    break;
                case 'surfercover':
                case 'surfer_cover':
                case 'esquivadorcover':
                case 'esquivador_cover':
                    mockMessage.type = 'surfer_cover_shown';
                    break;
                case 'pluckingrooster':
                case 'rooster':
                case 'pegalepersonaje':
                    mockMessage.type = 'qrpluckingrooster';
                    break;
                default:
                    console.warn(`[SaaS Connector] Dinámica '${templateName}' no tiene un mapeo de inicialización directa en el switch.`);
                    break;
            }

            if (mockMessage.type) {
                handleIncomingMessage(mockMessage);
            }
        };

        const connect = async () => {
            let matchedTemplate = null;
            let configData = null;

            if (roomId) {
                try {
                    const apiBase = process.env.REACT_APP_API_URL || 'https://localhost:50586/api/';
                    const res = await fetch(`${apiBase}v2/rooms/${roomId}/bootstrap`);
                    if (res.ok) {
                        const data = await res.json();
                        matchedTemplate = data.nombreIdentificador;
                        
                        if (data.datosDinamica) {
                            if (typeof data.datosDinamica === 'string') {
                                try {
                                    configData = JSON.parse(data.datosDinamica);
                                } catch (e) {
                                    console.error("[SaaS Connector] Error al deserializar datosDinamica string:", e);
                                    configData = data.datosDinamica;
                                }
                            } else {
                                configData = data.datosDinamica;
                            }
                        }
                        bootstrapConfigRef.current = configData;
                    } else {
                        console.warn(`[SaaS Connector] Bootstrap falló con status ${res.status}. Fallback a V1.`);
                    }
                } catch (err) {
                    console.error("[SaaS Connector] Error durante el bootstrap. Fallback a V1:", err);
                }
            }

            try {
                const response = await GetGenderMode()
                if (response && response.success) {
                    setIsActiveWomensMode(response.data.isWomensModeActive)
                } else {
                    setIsActiveWomensMode(false)
                }
            } catch (err) {
                setIsActiveWomensMode(false)
            }

            // Rehidratación ante F5 para Riddle (consulta de estado actual de la sala)
            try {
                const apiBase = process.env.REACT_APP_API_URL || 'https://localhost:50586/api/';
                const riddleUrl = roomId ? `${apiBase}riddle/getRoomState?roomId=${roomId}` : `${apiBase}riddle/getRoomState`;
                const headers = {};
                if (roomId) {
                    headers['X-Room-Id'] = roomId;
                    headers['roomId'] = roomId;
                }
                const resRiddle = await fetch(riddleUrl, { headers });
                if (resRiddle.ok) {
                    const riddleState = await resRiddle.json();
                    if (riddleState) {
                        const isRiddleActive = riddleState.isDynamicActive || 
                            riddleState.dynamic?.toLowerCase() === 'riddle' || 
                            riddleState.idTile === 10 || 
                            riddleState.idTile === 10.1 || 
                            riddleState.idTile === 11 || 
                            riddleState.idTile === 11.1;

                        if (isRiddleActive) {
                            if (riddleState.currentQuestionData) {
                                setQuestion(riddleState.currentQuestionData);
                                setActiveComponent(11.1);
                            } else if (riddleState.isDynamicActive || riddleState.currentQuestionId > 0) {
                                setActiveComponent(11);
                            }
                        }
                    }
                }
            } catch (err) {
                console.warn('[Screen] Error al rehidratar estado de Riddle:', err);
            }

            // Registrar el handler ANTES de iniciar la conexión SignalR
            SetSocketMessageHandler(handleIncomingMessage)
            await ConnectWebSocketForScreen(setConnectionStatus, showToast, roomId)

            if (matchedTemplate) {
                triggerInitialLayout(matchedTemplate, configData);
            }
        }

        const handleIncomingMessage = async (message) => {
            if (!message || !message.type) return

            // Filtro estricto de roomId para aislamiento total (compartimento estanco)
            const messageRoomId = message.roomId || message.RoomId;
            if (roomId) {
                // Modo Stand V2 (Con roomId): Solo acepta mensajes dirigidos expresamente a su sala.
                // Si el mensaje no trae roomId o no coincide, se descarta por completo.
                if (!messageRoomId || String(messageRoomId).toLowerCase() !== String(roomId).toLowerCase()) {
                    console.log(`[Screen] Aislamiento SaaS: Mensaje '${message.type}' ignorado. ID de sala del mensaje: ${messageRoomId}, ID de sala local: ${roomId}`);
                    return;
                }
            } else {
                // Modo Estadio V1 (Sin roomId en la URL): Procesa todos los mensajes emitidos hacia la pantalla del estadio.
            }

            // Traducir mensajes V2 SaaS a V1 para compatibilidad del switch/case
            const messageType = message.type.toLowerCase();
            if (messageType.startsWith('trivia.')) {
                if (messageType === 'trivia.layout' || messageType === 'trivia.start') {
                    message.type = 'quizzwithimageandoptions';
                } else if (messageType === 'trivia.question') {
                    message.type = 'newquestionquizzwithimageandoptions';
                }
            } else if (messageType.startsWith('roulette.')) {
                if (messageType === 'roulette.layout' || messageType === 'roulette.prepare') {
                    message.type = 'roulette.prepare';
                }
            } else if (messageType.startsWith('riddle.')) {
                if (messageType === 'riddle.layout' || messageType === 'riddle.frontpage' || messageType === 'riddle.cover') {
                    message.type = 'riddle';
                } else if (messageType === 'riddle.question' || messageType === 'riddle.resume') {
                    message.type = 'newquestionriddler';
                } else if (messageType === 'riddle.displayitem' || messageType === 'riddle.item') {
                    message.type = 'riddledisplayitem';
                } else if (messageType === 'riddle.votingclosed' || messageType === 'riddle.closevoting') {
                    message.type = 'riddlevotingclosed';
                }
            } else if (messageType.startsWith('sequence.')) {
                if (messageType === 'sequence.layout' || messageType === 'sequence.prepare' || messageType === 'sequence.start') {
                    message.type = 'sequence.layout';
                } else if (messageType === 'sequence.frontpage' || messageType === 'sequence.cover') {
                    message.type = 'sequence.frontpage';
                }
            } else if (messageType.startsWith('memory.')) {
                if (messageType === 'memory.cover' || messageType === 'memory.frontpage') {
                    message.type = 'memory_cover_shown';
                } else if (messageType === 'memory.game_scene' || messageType === 'memory.gamescene' || messageType === 'memory.ready' || messageType === 'memory.layout' || messageType === 'memory.created') {
                    message.type = 'memory_game_scene_shown';
                } else if (messageType === 'memory.countdown') {
                    message.type = 'memory_countdown_started';
                } else if (messageType === 'memory.preview') {
                    message.type = 'memory_preview_start';
                } else if (messageType === 'memory.started' || messageType === 'memory.start') {
                    message.type = 'memory_game_started';
                } else if (messageType === 'memory.finished' || messageType === 'memory.game_over') {
                    message.type = 'memory_game_finished';
                } else if (messageType === 'memory.reset') {
                    message.type = 'memory_game_reset';
                }
            } else if (messageType.startsWith('tugofwar.') || messageType.startsWith('tug_of_war.')) {
                if (messageType.endsWith('.cover') || messageType.endsWith('.frontpage')) {
                    message.type = 'tugofwar_cover_shown';
                } else if (messageType.endsWith('.game_scene') || messageType.endsWith('.gamescene') || messageType.endsWith('.ready') || messageType.endsWith('.layout') || messageType.endsWith('.created')) {
                    message.type = 'tugofwar_game_scene_shown';
                } else if (messageType.endsWith('.countdown')) {
                    message.type = 'tugofwar_countdown_started';
                } else if (messageType.endsWith('.started') || messageType.endsWith('.start') || messageType.endsWith('.round_started')) {
                    message.type = 'tugofwar_round_started';
                } else if (messageType.endsWith('.telemetry') || messageType.endsWith('.state')) {
                    message.type = 'tugofwar_telemetry';
                } else if (messageType.endsWith('.sudden_death') || messageType.endsWith('.suddendeath')) {
                    message.type = 'tugofwar_sudden_death_started';
                } else if (messageType.endsWith('.paused') || messageType.endsWith('.pause')) {
                    message.type = 'tugofwar_paused';
                } else if (messageType.endsWith('.resumed') || messageType.endsWith('.resume')) {
                    message.type = 'tugofwar_resumed';
                } else if (messageType.endsWith('.finished') || messageType.endsWith('.game_over')) {
                    message.type = 'tugofwar_game_over';
                } else if (messageType.endsWith('.reset')) {
                    message.type = 'tugofwar_match_reset';
                }
            }

            // Inyectar la configuración del bootstrap de forma transparente en payload y data
            if (bootstrapConfigRef.current) {
                message.payload = typeof message.payload === 'object' && message.payload !== null
                    ? { ...bootstrapConfigRef.current, ...message.payload }
                    : { ...bootstrapConfigRef.current };

                message.data = typeof message.data === 'object' && message.data !== null
                    ? { ...bootstrapConfigRef.current, ...message.data }
                    : { ...bootstrapConfigRef.current };
            }

            switch (message.type.toLowerCase()) {
                case 'gendermode': {
                    const incomingData = message.data || message.payload || {};
                    const isWomens = typeof incomingData === 'boolean'
                        ? incomingData
                        : (incomingData.isActiveWomensMode ?? incomingData.isWomensModeActive ?? false);
                    setIsActiveWomensMode(Boolean(isWomens));
                    break;
                }
                case 'set.dynamic': {
                    const dyn = message.data?.dynamic?.toLowerCase();
                    if (dyn === 'wait') {
                        setLottery(null); setQuestion(null); setResults(null);
                        setActiveComponent(1);
                    } else if (dyn === 'welcome' || dyn === 'start') {
                        setLottery(null); setQuestion(null); setResults(null);
                        setActiveComponent(9);
                    } else if (dyn === 'thanks') {
                        setLottery(null); setQuestion(null); setResults(null);
                        setActiveComponent(8);
                    }
                    break;
                }

                case 'welcome':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(9)
                    break

                case 'wait':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(1)
                    break

                case 'newinstruction':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(2)
                    break

                case 'trivia':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(3)
                    break

                case 'finalresults':
                    setLottery(null); setQuestion(null); setResults(message);
                    setActiveComponent(3.1)
                    break

                case 'loteria':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(4)
                    break

                case 'lotterycard':
                    setLottery(message); setQuestion(null); setResults(null);
                    setActiveComponent(4.1)
                    break

                case 'colores':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(6)
                    break

                case 'setzonecolor':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(6.1)
                    break

                case 'start':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(7)
                    break

                case 'thanks':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(8)
                    break

                // ───────────── RunToGoal (V1 y V2) ─────────────
                // // 1. AGRUPAMOS LOS 3 EVENTOS DE LIMPIEZA AQUÍ:
                // case 'goal':
                // case 'goal.layout':
                // case 'goal.prepare':
                // case 'goal.reset':
                //     SetGoalAndRoute(g => ({
                //         ...g,
                //         state: 'Waiting',
                //         phase: 'Waiting',
                //         elapsedMilliseconds: 0, // CRÍTICO PARA LANZAR LA PORTADA (5.3)
                //         progressLucho: 0,
                //         progressTunita: 0,
                //         winner: null,
                //         zonesProgress: []
                //     }))
                //     break

                // case 'goal.created': {
                //     const cfg = message.payload?.cfg || {}
                //     SetGoalAndRoute({
                //         matchId: message.payload?.matchId ?? null,
                //         state: 'Waiting',
                //         phase: 'Waiting',
                //         elapsedMilliseconds: 0, // CRÍTICO PARA EL RESET V2
                //         totalDurationMilliseconds: (cfg.durationSeconds || 15) * 1000,
                //         progressLucho: 0,
                //         progressTunita: 0,
                //         tapsParaGanar: cfg.tapsParaGanar ?? 100,
                //         winner: null,
                //         zonesProgress: []
                //     })
                //     break
                // }

                // Estos 4 eventos ahora hacen exactamente lo mismo: Limpiar la memoria y mostrar la portada (5.3)
                case 'goal.frontpage':
                case 'goal.layout':
                case 'goal.prepare':
                case 'goal.reset': {
                    const p = message.payload || message.data || {};
                    const incomingTheme = p.theme || p.Theme || (p.cfg && (p.cfg.theme || p.cfg.Theme)) || null;
                    SetGoalAndRoute(g => ({
                        ...g,
                        matchId: p.matchId ?? null,
                        state: 'Waiting',
                        phase: 'Waiting',
                        elapsedMilliseconds: 0,
                        progressLucho: 0,
                        progressTunita: 0,
                        tapsParaGanar: 100,
                        winner: null,
                        zonesProgress: [],
                        theme: incomingTheme || g.theme
                    }))
                    break
                }

                case 'goal.created': {
                    const p = message.payload || message.data || {};
                    const cfg = p.cfg || {}
                    const incomingTheme = p.theme || p.Theme || cfg.theme || cfg.Theme || null;
                    SetGoalAndRoute(g => ({
                        ...g,
                        matchId: p.matchId ?? null,
                        state: 'Waiting',
                        phase: 'Waiting',
                        elapsedMilliseconds: 0,
                        totalDurationMilliseconds: (cfg.durationSeconds || 15) * 1000,
                        progressLucho: 0,
                        progressTunita: 0,
                        tapsParaGanar: cfg.tapsParaGanar ?? 100,
                        winner: null,
                        zonesProgress: [],
                        theme: incomingTheme || g.theme
                    }))
                    break
                }

                case 'goal.snapshot': {
                    const p = message.payload || message.data || {}
                    const incomingTheme = p.theme || p.Theme || (p.cfg && (p.cfg.theme || p.cfg.Theme)) || null;
                    SetGoalAndRoute(g => ({
                        ...g,
                        ...p,
                        matchId: p.matchId ?? g.matchId ?? null,
                        state: p.state ?? 'Waiting',
                        phase: p.state ?? 'Waiting',
                        elapsedMilliseconds: p.elapsedMilliseconds !== undefined ? p.elapsedMilliseconds : g.elapsedMilliseconds,
                        progressLucho: p.progressLucho ?? g.progressLucho ?? 0,
                        progressTunita: p.progressTunita ?? g.progressTunita ?? 0,
                        tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar ?? 100,
                        winner: p.winner ?? g.winner ?? null,
                        theme: incomingTheme || g.theme
                    }))
                    break
                }

                case 'goal.started': {
                    const p = message.payload || message.data || {};
                    const incomingTheme = p.theme || p.Theme || null;
                    SetGoalAndRoute(g => ({
                        ...g,
                        state: 'Running',
                        phase: 'Running',
                        winner: null,
                        progressLucho: 0,
                        progressTunita: 0,
                        theme: incomingTheme || g.theme
                    }))
                    break
                }

                case 'goal.progress': {
                    const p = message.payload || message.data || {}
                    const incomingTheme = p.theme || p.Theme || null;
                    if (p.elapsedMilliseconds !== undefined) {
                        // V2
                        SetGoalAndRoute(g => ({
                            ...g,
                            ...p,
                            state: 'Running',
                            phase: 'Running',
                            theme: incomingTheme || g.theme
                        }))
                    } else {
                        // V1
                        SetGoalAndRoute(g => ({
                            ...g,
                            state: 'Running',
                            phase: 'Running',
                            progressLucho: p.progressLucho ?? g.progressLucho,
                            progressTunita: p.progressTunita ?? g.progressTunita,
                            tapsParaGanar: p.tapsParaGanar ?? g.tapsParaGanar,
                            theme: incomingTheme || g.theme
                        }))
                    }
                    break
                }

                case 'goal.finished': {
                    const p = message.payload || message.data || {}
                    const incomingTheme = p.theme || p.Theme || null;
                    if (p.finalZonesProgress !== undefined) {
                        // V2
                        SetGoalAndRoute(g => ({
                            ...g,
                            ...p,
                            state: 'Finished',
                            phase: 'Finished',
                            winner: p.winner ?? null,
                            theme: incomingTheme || g.theme
                        }))
                    } else {
                        // V1
                        SetGoalAndRoute(g => ({
                            ...g,
                            state: 'Finished',
                            phase: 'Finished',
                            winner: p.winner ?? null,
                            progressLucho: p.progressLucho ?? g.progressLucho,
                            progressTunita: p.progressTunita ?? g.progressTunita,
                            theme: incomingTheme || g.theme
                        }))
                    }
                    break
                }

                // ───────────── Globos (pantalla) ─────────────
                case 'ballons': {
                    SetBalloonsAndRoute({
                        matchId: null, status: 'Waiting', startAt: null, endsAt: null,
                        target: 0, zones: [], winners: null
                    });
                    break;
                }

                case 'ballonsgame': {
                    SetBalloonsAndRoute(b => ({ ...b, status: 'Waiting' }));
                    break;
                }

                case 'balloon.prepare': {
                    const d = message.data || {}
                    const durationSec = (typeof d.matchDurationSec === 'number' && d.matchDurationSec > 0)
                        ? d.matchDurationSec
                        : ((d.endsAt && d.startAt) ? Math.max(0, Math.floor((Date.parse(d.endsAt) - Date.parse(d.startAt)) / 1000)) : 0)

                    const localCountdownMs = 3000
                    const localStartAt = Date.now() + localCountdownMs
                    const localEndsAt = localStartAt + (durationSec * 1000)

                    SetBalloonsAndRoute(b => ({
                        ...b,
                        matchId: d.matchId ?? d.MatchId ?? b.matchId,
                        status: 'Waiting',
                        startAt: new Date(localStartAt).toISOString(),
                        endsAt: new Date(localEndsAt).toISOString(),
                        target: d.targetTapsPerBalloon ?? d.TargetTapsPerBalloon ?? b.target,
                        winners: null
                    }))
                    break
                }

                case 'balloon.state': {
                    const st = message.data || {}
                    const rawStatus = st.status ?? st.Status
                    const statusNorm = rawStatus === 0 || rawStatus === 'Waiting' ? 'Waiting' :
                        rawStatus === 1 || rawStatus === 'Running' ? 'Running' :
                            rawStatus === 2 || rawStatus === 'Finished' ? 'Finished' : 'Waiting';

                    const matchId = st.matchId ?? st.MatchId ?? null
                    const target = st.targetTapsPerBalloon ?? st.TargetTapsPerBalloon ?? null

                    const zonesIn = st.zones ?? st.Zones;
                    const zonesNorm = Array.isArray(zonesIn)
                        ? zonesIn.map(z => ({
                            zone: (z.zone ?? z.Zone ?? '').toString(),
                            currentBalloonTaps: z.currentBalloonTaps ?? z.CurrentBalloonTaps ?? 0,
                            completedBalloons: z.completedBalloons ?? z.CompletedBalloons ?? 0,
                            totalTaps: z.totalTaps ?? z.TotalTaps ?? 0
                        }))
                        : null

                    SetBalloonsAndRoute(b => ({
                        ...b, matchId: matchId ?? b.matchId, status: statusNorm,
                        startAt: null, endsAt: null, target: target ?? b.target, zones: zonesNorm ?? b.zones
                    }))

                    if (statusNorm === 'Running') forceUIStatus('Running')
                    if (statusNorm === 'Finished') forceUIStatus('Finished')
                    break
                }

                case 'balloon.show-winners': {
                    const d = message.data || {}
                    SetBalloonsAndRoute(b => ({
                        ...b,
                        matchId: d.matchId ?? b.matchId,
                        status: 'Finished',
                        winners: { winnerType: d.winnerType || 'none', winners: d.winners || [], results: d.results || [] }
                    }))
                    forceUIStatus('Finished')
                    break
                }

                case 'balloon.reset': {
                    if (countdownTimerRef.current) { clearTimeout(countdownTimerRef.current); countdownTimerRef.current = null; }
                    SetBalloonsAndRoute({ matchId: null, status: 'Waiting', startAt: null, endsAt: null, target: 0, zones: [], winners: null });
                    setBalloonsUI({ uiStatus: 'Idle', countdownUntil: null });
                    break;
                }

                case 'riddle':
                case 'riddle.cover':
                case 'riddle.frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(11);
                    break;

                case 'newquestionriddler':
                case 'resumequestionriddler':
                case 'riddledisplayitem':
                case 'riddlevotingclosed':
                case 'riddle.displayitem':
                case 'riddle.votingclosed':
                case 'riddle.question':
                    setLottery(null); setQuestion(message.data || message.payload); setResults(null);
                    setActiveComponent(11.1);
                    break;

                case 'deselectedselfiefan':
                case 'resetselfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12)
                    break

                case 'displayselfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12.1)
                    break

                case 'selfiefan':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(13)
                    break

                case 'displayselfiefania':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(14)
                    break

                case 'deselectedselfiefania':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(12)
                    break

                case 'quizzwithimageandoptions':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(15)
                    break

                case 'newquestionquizzwithimageandoptions':
                case 'resumequestionquizzwithimageandoptions':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(15.1)
                    break

                case 'frontpagenoisemeter':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(16)
                    break

                case 'noisemeter.prepare':
                case 'noisemeter.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(16.1)
                    break

                case 'qrmessages':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(17)
                    break

                case 'qrpluckingrooster':
                    setLottery(null); setQuestion(message.data || message.payload || message); setResults(null);
                    setActiveComponent(18);
                    break;

                case 'rankingpluckingrooster':
                case 'update_rankingpluckingrooster':
                case 'rooster.ranking_updated':
                case 'rooster.ranking':
                    setLottery(null); setQuestion(message.data || message.payload || message); setResults(null);
                    setActiveComponent(19);
                    break;

                case 'frontpageluchofest':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(20)
                    break

                case "luchofest.game_running":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'playing' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.show_winner":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'winner' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.show_practice_finished":
                    setLottery(null)
                    setQuestion({ ...message.data, viewType: 'practice' })
                    setResults(null)
                    setActiveComponent(20.1)
                    break

                case "luchofest.stop":
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(20)
                    break

                case 'picnic.layout':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(21)
                    break

                case 'picnic.finished':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(21.1)
                    break

                // ==========================================
                // DINÁMICA: VAS O NO VAS (MALETINES)
                // ==========================================
                case 'briefcase.layout':
                    // Limpiamos basura de otros juegos
                    setLottery(null); setQuestion(null); setResults(null);
                    // Seteamos una vista previa por defecto (9 maletines cerrados) en lo que arranca
                    setBriefcaseState({
                        phase: 'WAITING',
                        briefcases: Array.from({ length: 9 }, (_, i) => ({ id: i + 1, state: 'closed', prizeTheme: 'none' })),
                        suspenseBriefcaseId: null,
                        revealData: null
                    });
                    setActiveComponent(22);
                    break;

                case 'briefcase.update':
                    // El backend nos mandará el estado completo del juego cada que el Admin abra un maletín
                    if (message.payload) {
                        setBriefcaseState(message.payload);
                        setActiveComponent(22.1);
                    }
                    break;

                // ==========================================
                // DINÁMICA: Velocidad taquera
                // ==========================================
                case 'taco.layout':
                case 'taco.reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTacoMatchState(null); // Limpiamos para volver a la configuración base
                    setActiveComponent(23.1); 
                    break;

                case 'taco.progress':
                case 'taco.finished':
                    if (message.payload) {
                        setTacoMatchState(message.payload);
                        setActiveComponent(23.1);
                    }
                    break;

                case 'taco.frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTacoMatchState(message.customConfig ? { customConfig: message.customConfig } : null);
                    setActiveComponent(23); 
                    break;

                case 'catchtheball':
                    setCatchMatchState(message.data); // data trae action y payload
                    setActiveComponent(24); // Usamos el ID 24 para esta dinámica
                    break;

                // ───────────── Tragamonedas ─────────────
                case 'slotmachine.enter':
                case 'slotmachine.prepare':
                case 'slotmachine.spin':
                case 'slotmachine.toggleqr':
                case 'slotmachine.togglethanks':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    
                    // Guardamos el mensaje completo para pasárselo a la máquina
                    setSlotPayload(message);
                    
                    // Aseguramos que el componente 25 esté en pantalla
                    setActiveComponent(25);
                    break;

                case 'voting.start':
                    setLottery(null); setQuestion(message.data); setResults(null);
                    setActiveComponent(26); // Usaremos el 30 para la votación en pantalla
                    break;
                case 'voting.results':
                    setLottery(null); setQuestion(null); setResults(message.data);
                    setActiveComponent(26.1); 
                    break;

                // ==========================================
                // DINÁMICA: GORRAS / BOLITA (CAPS)
                // ==========================================
                case 'caps.layout':
                    setLottery(null); setQuestion(null); setResults(null);
                    setCapsMatchState(null);
                    setActiveComponent(27); // Mostramos Portada
                    break;

                case 'caps.progress':
                case 'caps.reset':
                    if (message.payload) {
                        setCapsMatchState(message.payload);
                    } else {
                        setCapsMatchState(null);
                    }
                    setActiveComponent(27.1); // Mostramos Juego
                    break;

                // ───────────── Ruleta ─────────────
                case 'roulette.prepare':
                case 'roulette.spin':
                case 'roulette.toggleqr':
                case 'roulette.togglethanks':
                    setLottery(null);
                    setQuestion(null);
                    setResults(null);
                    
                    // Guardamos el mensaje completo para la ruleta
                    setRoulettePayload(message);
                    
                    // Aseguramos que el componente 28 esté en pantalla
                    setActiveComponent(28);
                    break;

                case 'showlightshowqr':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(29)
                    break

                // ==========================================
                // DINÁMICA: CARRERA CONTINUA (HU-06)
                // ==========================================
                case 'carreracontinua.cover':
                    setLottery(null); setQuestion(null); setResults(null);
                    setCarreraMatchState(prev => ({
                        ...(prev || {}),
                        ...(message.payload || message.data || {})
                    }));
                    setActiveComponent(30);
                    break;

                case 'carreracontinua.finished':
                    setLottery(null); setQuestion(null); setResults(null);
                    setCarreraMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'FINISHED',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(30.1);
                    break;

                case 'carreracontinua.reset': {
                    setLottery(null); setQuestion(null); setResults(null);
                    setCarreraMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.state || incoming.payload || incoming;
                        const preservedTheme = incoming.theme || stateData.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        const cleanRunners = (stateData.zonesProgress && stateData.zonesProgress.length > 0)
                            ? stateData.zonesProgress.map(z => ({
                                ...z,
                                totalTaps: 0,
                                scorePerCapita: 0,
                                visualPositionPercentage: 0
                            }))
                            : (preservedTheme?.runners || prev?.runners || []).map((r, idx) => ({
                                zoneIdentifier: r.zoneIdentifier || r.zoneId || `zona${idx + 1}`,
                                totalTaps: 0,
                                scorePerCapita: 0,
                                visualPositionPercentage: 0
                            }));

                        return {
                            roomId: incoming.roomId || prev?.roomId,
                            phase: 'WAITING',
                            elapsedMilliseconds: 0,
                            progressPercentage: 0,
                            currentLeadingKilometer: 0,
                            winnerZone: null,
                            winner: null,
                            isTie: false,
                            triggeredArchIndexes: [],
                            finalResults: [],
                            zonesProgress: cleanRunners,
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(30.1);
                    break;
                }

                case 'carreracontinua.created':
                case 'carreracontinua.countdown':
                case 'carreracontinua.started':
                case 'carreracontinua.progress':
                case 'carreracontinua.paused':
                case 'carreracontinua.resumed':
                case 'carreracontinua.arch_triggered':
                    setLottery(null); setQuestion(null); setResults(null);
                    setCarreraMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            theme: preservedTheme || prev?.theme,
                            defaultArchImageUrl: incoming.defaultArchImageUrl || incoming.archImageUrl || preservedTheme?.defaultArchImageUrl || prev?.defaultArchImageUrl,
                            checkpoints: incoming.checkpoints || preservedTheme?.checkpoints || prev?.checkpoints
                        };
                    });
                    setActiveComponent(30.1);
                    break;

                // ==========================================
                // DINÁMICA: FIGHTERS (HU-06)
                // ==========================================
                case 'fighters_cover_shown':
                case 'fighters.cover':
                case 'fighters_cover':
                case 'fighters:cover':
                    setLottery(null); setQuestion(null); setResults(null);
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'cover',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(42);
                    break;

                case 'fighters_game_scene_shown':
                case 'fighters.gamescene':
                case 'fighters_game_scene':
                case 'fighters:gamescene':
                    setLottery(null); setQuestion(null); setResults(null);
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'game_ready',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_countdown_started':
                case 'fighters_countdown':
                case 'fighters:countdown':
                    setLottery(null); setQuestion(null); setResults(null);
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'countdown',
                            countdown: incoming.countdown ?? incoming.secondsRemaining ?? 3
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_round_started':
                case 'fighters_started':
                case 'fighters:started':
                    setLottery(null); setQuestion(null); setResults(null);
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'playing'
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_telemetry':
                case 'telemetry':
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            theme: incoming.theme || prev?.theme
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_combo_triggered':
                case 'fighters_combo':
                case 'fighters:combo':
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            lastComboEvent: incoming
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_deck_transform':
                case 'deck_transform':
                case 'fighters:deck_transform':
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const playerKey = incoming.playerChoice === 'player2' ? 'player2' : 'player1';
                        return {
                            ...(prev || {}),
                            lastDeckTransform: incoming,
                            [playerKey]: {
                                ...(prev?.[playerKey] || {}),
                                currentDeckImage: incoming.deckImageUrl,
                                currentDeckIndex: incoming.deckSlotIndex
                            }
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_game_over':
                case 'fighters_finished':
                case 'fighters:finished':
                    setLottery(null); setQuestion(null); setResults(null);
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'finished'
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_game_reset':
                case 'fighters_reset':
                case 'fighters:reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setFightersMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'idle',
                            secondsRemaining: incoming.durationSeconds || prev?.durationSeconds || 10,
                            player1: { ...(prev?.player1 || {}), score: 0, totalTaps: 0 },
                            player2: { ...(prev?.player2 || {}), score: 0, totalTaps: 0 },
                            winner: null,
                            lastComboEvent: null,
                            lastDeckTransform: null
                        };
                    });
                    setActiveComponent(42.1);
                    break;

                case 'fighters_paused':
                case 'fighters_match_paused':
                case 'fighters:paused':
                    setFightersMatchState(prev => ({
                        ...(prev || {}),
                        phase: 'paused'
                    }));
                    break;

                case 'fighters_resumed':
                case 'fighters_match_resumed':
                case 'fighters:resumed':
                    setFightersMatchState(prev => ({
                        ...(prev || {}),
                        phase: 'playing'
                    }));
                    break;

                // ==========================================
                // DINÁMICA: REACCIÓN RÁPIDA 1 VS 1 (HU-06)
                // ==========================================
                case 'quick_reaction_cover_shown':
                case 'quick_reaction_cover':
                case 'quickreaction.cover':
                case 'quickreaction_cover':
                case 'quickreaction.layout':
                case 'quickreaction.frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'cover',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(43);
                    break;

                case 'quick_reaction_game_scene_shown':
                case 'quick_reaction_game_shown':
                case 'quick_reaction_game':
                case 'quick_reaction:game':
                case 'quickreaction.game':
                case 'quickreaction.gamescene':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'game_ready',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_countdown_tick':
                case 'quick_reaction_countdown':
                case 'quickreaction.countdown':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'countdown',
                            countdownSeconds: incoming.count ?? incoming.secondsRemaining ?? incoming.countdownSeconds ?? 3
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_random_wait':
                case 'quickreaction.random_wait':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'random_wait',
                            countdownSeconds: 0
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_trigger_active':
                case 'quickreaction.trigger_active':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'trigger_active',
                            triggerTimestampServerMs: incoming.triggerTimestampServerMs || Date.now()
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_early_fault':
                case 'quickreaction.early_fault':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const faultSide = incoming.faultSide;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'finished',
                            winnerSide: incoming.winnerSide || (faultSide === 'J1' ? 'J2' : 'J1'),
                            winnerName: incoming.winnerName,
                            winReason: 'OPPONENT_FAULT',
                            player1: {
                                ...(prev?.player1 || {}),
                                earlyFault: faultSide === 'J1' || incoming.player1?.earlyFault
                            },
                            player2: {
                                ...(prev?.player2 || {}),
                                earlyFault: faultSide === 'J2' || incoming.player2?.earlyFault
                            }
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_match_finished':
                case 'quick_reaction_finished':
                case 'quickreaction.finished':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'finished',
                            winnerSide: incoming.winner ?? incoming.winnerSide ?? prev?.winnerSide,
                            winnerName: incoming.winnerName ?? prev?.winnerName,
                            winReason: incoming.winReason ?? prev?.winReason
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_reset':
                case 'quick_reaction_game_ready':
                case 'quickreaction.reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'game_ready',
                            countdownSeconds: 0,
                            winnerSide: null,
                            winnerName: null,
                            winReason: null,
                            player1: { ...(prev?.player1 || {}), reactionTimeMs: null, earlyFault: false },
                            player2: { ...(prev?.player2 || {}), reactionTimeMs: null, earlyFault: false }
                        };
                    });
                    setActiveComponent(43.1);
                    break;

                case 'quick_reaction_player_joined':
                case 'quick_reaction_player_left':
                    setQuickReactionMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...(incoming.state || incoming)
                        };
                    });
                    break;

                case 'playlist':
                case 'playlist.layout':
                case 'armalaplaylist':
                case 'arma_la_playlist':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(45);
                    break;

                // ==========================================
                // DINÁMICA: MEMORAMA (MEMORY 1 VS 1) (HU-06)
                // ==========================================
                case 'memory_cover_shown':
                case 'memory_cover':
                case 'memory.cover':
                case 'memory_frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        const preservedTheme = incoming.theme || stateData.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            phase: 'cover',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(46);
                    break;

                case 'memory_game_scene_shown':
                case 'memory_game_ready':
                case 'memory_game_shown':
                case 'memory.gamescene':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        const preservedTheme = incoming.theme || stateData.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_game_ready',
                            phase: 'game_ready',
                            winner: null,
                            winningReason: '',
                            lastFlipEvent: null,
                            lastMatchSuccessEvent: null,
                            lastMatchFailedEvent: null,
                            lastCardsUnflippedEvent: null,
                            payload: incoming,
                            player1: {
                                ...(stateData.player1 || prev?.player1 || {}),
                                score: 0,
                                totalFlips: 0
                            },
                            player2: {
                                ...(stateData.player2 || prev?.player2 || {}),
                                score: 0,
                                totalFlips: 0
                            },
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_countdown_started':
                case 'memory_countdown':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_countdown',
                            phase: 'countdown',
                            countdownNumber: incoming.countdownSeconds ?? incoming.count ?? incoming.step ?? 3,
                            winner: null,
                            winningReason: '',
                            lastFlipEvent: null,
                            lastMatchSuccessEvent: null,
                            lastMatchFailedEvent: null,
                            lastCardsUnflippedEvent: null,
                            payload: incoming,
                            player1: {
                                ...(stateData.player1 || prev?.player1 || {}),
                                score: 0,
                                totalFlips: 0
                            },
                            player2: {
                                ...(stateData.player2 || prev?.player2 || {}),
                                score: 0,
                                totalFlips: 0
                            }
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_preview_start':
                case 'memory_preview':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_preview',
                            countdownNumber: null,
                            lastFlipEvent: null,
                            lastMatchSuccessEvent: null,
                            lastMatchFailedEvent: null,
                            lastCardsUnflippedEvent: null,
                            payload: incoming,
                            ...(stateData.player1 ? { player1: stateData.player1, player2: stateData.player2 } : {}),
                            phase: 'preview',
                            previewRemainingSeconds: incoming.previewTimeSeconds ?? prev?.previewTimeSeconds ?? 3
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_preview_tick':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            type: 'memory_preview_tick',
                            countdownNumber: null,
                            previewRemainingSeconds: incoming.previewTimeSeconds ?? incoming.remainingSeconds ?? prev?.previewRemainingSeconds
                        };
                    });
                    break;

                case 'memory_preview_ended':
                    setMemoryMatchState(prev => ({
                        ...(prev || {}),
                        type: 'memory_preview_ended',
                        countdownNumber: null,
                        phase: 'playing'
                    }));
                    break;

                case 'memory_game_started':
                case 'memory_playing_started':
                case 'memory_start':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_start',
                            countdownNumber: null,
                            phase: 'playing',
                            winner: null,
                            winningReason: '',
                            lastFlipEvent: null,
                            lastMatchSuccessEvent: null,
                            lastMatchFailedEvent: null,
                            lastCardsUnflippedEvent: null,
                            payload: incoming
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_telemetry':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_telemetry',
                            countdownNumber: null,
                            phase: incoming.phase || stateData.phase || prev?.phase || 'playing',
                            ...(stateData.player1 ? { player1: stateData.player1, player2: stateData.player2 } : {}),
                            theme: incoming.theme || stateData.theme || prev?.theme
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_card_flipped':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            lastFlipEvent: incoming,
                            type: 'memory_card_flipped',
                            payload: incoming
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_match_success':
                case 'match_success':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            lastMatchSuccessEvent: incoming,
                            type: 'memory_match_success',
                            payload: incoming
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_match_failed':
                case 'match_failed':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            lastMatchFailedEvent: incoming,
                            type: 'memory_match_failed',
                            payload: incoming
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_cards_unflipped':
                case 'cards_unflipped':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            lastCardsUnflippedEvent: incoming,
                            type: 'memory_cards_unflipped',
                            payload: incoming
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_game_finished':
                case 'memory_finished':
                case 'memory_game_over':
                case 'memory_all_pairs_matched':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_game_finished',
                            countdownNumber: null,
                            phase: 'finished',
                            winner: incoming.winner || incoming.winnerSide || stateData.winner || prev?.winner,
                            winningReason: incoming.winningReason || incoming.reason || stateData.winningReason || prev?.winningReason
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_game_reset':
                case 'memory_reset':
                case 'memory_match_reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        const preservedTheme = incoming.theme || stateData.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            type: 'memory_match_reset',
                            phase: 'game_ready',
                            winner: null,
                            winningReason: '',
                            lastFlipEvent: null,
                            lastMatchSuccessEvent: null,
                            lastMatchFailedEvent: null,
                            lastCardsUnflippedEvent: null,
                            payload: incoming,
                            player1: {
                                ...(stateData.player1 || prev?.player1 || {}),
                                score: 0,
                                ...(stateData.player2 || prev?.player2 || {}),
                                score: 0,
                                totalFlips: 0
                            },
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(46.1);
                    break;

                case 'memory_names_updated':
                case 'memory_update_names':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            player1Name: incoming.player1Name || incoming.player1 || prev?.player1Name,
                            player2Name: incoming.player2Name || incoming.player2 || prev?.player2Name,
                            player1: {
                                ...(prev?.player1 || {}),
                                name: incoming.player1Name || incoming.player1 || prev?.player1?.name
                            },
                            player2: {
                                ...(prev?.player2 || {}),
                                name: incoming.player2Name || incoming.player2 || prev?.player2?.name
                            }
                        };
                    });
                    break;

                case 'memory_sync_state':
                case 'memory_state':
                    setMemoryMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || {};
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming,
                            ...(stateData.player1 ? { player1: stateData.player1, player2: stateData.player2 } : {})
                        };
                    });
                    break;

                // ==========================================
                // DINÁMICA: SECUENCIA (SIMON SAYS) (HU-06)
                // ==========================================
                case 'sequence.frontpage':
                case 'sequence.cover':
                case 'sequence_cover':
                case 'sequence_frontpage':
                    setLottery(null); setQuestion(null); setResults(null);
                    setActiveComponent(48);
                    break;

                case 'sequence.layout':
                case 'sequence.update':
                case 'sequence.reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSequencePayload(message);
                    setActiveComponent(48.1);
                    break;

                // ==========================================
                // DINÁMICA: ESTIRA Y AFLOJA (TUG OF WAR) (HU-06)
                // ==========================================
                case 'tugofwar_cover_shown':
                case 'tugofwar_cover':
                case 'tugofwar.cover':
                case 'tug_of_war_cover':
                case 'estirayafloja_cover':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'cover',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(47);
                    break;

                case 'tugofwar_game_scene_shown':
                case 'tugofwar_game_ready':
                case 'tugofwar_game_shown':
                case 'tugofwar.gamescene':
                case 'tugofwar_game':
                case 'tug_of_war_game':
                case 'estirayafloja_game':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'game_ready',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_countdown_started':
                case 'tugofwar_countdown_tick':
                case 'tugofwar_countdown':
                case 'tugofwar.countdown':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'countdown',
                            countdownNumber: incoming.countdownNumber ?? incoming.countdownSeconds ?? incoming.count ?? incoming.step ?? 3
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_round_started':
                case 'tugofwar_match_started':
                case 'tugofwar_started':
                case 'tugofwar.start':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'playing'
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_telemetry':
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            theme: incoming.theme || prev?.theme
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_sudden_death_started':
                case 'tugofwar_sudden_death':
                case 'tugofwar.sudden_death':
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            isSuddenDeath: true
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_paused':
                case 'tugofwar_match_paused':
                case 'tugofwar:paused':
                    setTugOfWarMatchState(prev => ({
                        ...(prev || {}),
                        phase: 'paused'
                    }));
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_resumed':
                case 'tugofwar_match_resumed':
                case 'tugofwar:resumed':
                    setTugOfWarMatchState(prev => ({
                        ...(prev || {}),
                        phase: 'playing'
                    }));
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_game_over':
                case 'tugofwar_finished':
                case 'tugofwar.finished':
                case 'tugofwar_match_finished':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'finished',
                            winner: incoming.winner || incoming.winnerSide || prev?.winner
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'tugofwar_match_reset':
                case 'tugofwar_game_reset':
                case 'tugofwar_reset':
                case 'tugofwar.reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setTugOfWarMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'idle',
                            score1: 0,
                            score2: 0,
                            totalTaps1: 0,
                            totalTaps2: 0,
                            winner: null,
                            isSuddenDeath: false
                        };
                    });
                    setActiveComponent(47.1);
                    break;

                case 'surfer_cover_shown':
                case 'surfer_cover':
                case 'surfer:cover':
                case 'esquivador_cover':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'cover',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(51);
                    break;

                case 'surfer_game_scene_shown':
                case 'surfer_game_ready':
                case 'surfer_game_shown':
                case 'surfer_game':
                case 'surfer:gamescene':
                case 'surfer:game':
                case 'esquivador_game':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const preservedTheme = incoming.theme || (incoming.themeSnapshotJson ? incoming : null) || prev?.theme;
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'game_ready',
                            theme: preservedTheme || prev?.theme
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_countdown_started':
                case 'surfer_countdown_tick':
                case 'surfer_countdown':
                case 'surfer:countdown':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'countdown',
                            countdownSeconds: incoming.countdownSeconds ?? incoming.countdownNumber ?? incoming.count ?? incoming.step ?? 3
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_match_started':
                case 'surfer_started':
                case 'surfer:started':
                case 'surfer_start':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'running'
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_telemetry':
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            theme: incoming.theme || prev?.theme,
                            config: incoming.config || prev?.config
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_player_action_received':
                case 'surfer_player_action':
                case 'surfer:player_action':
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || incoming;
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_player_hit':
                case 'surfer:player_hit':
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || incoming;
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_score_updated':
                case 'surfer:score_updated':
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        const stateData = incoming.matchState || incoming.state || incoming;
                        return {
                            ...(prev || {}),
                            ...stateData,
                            ...incoming
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_match_paused':
                case 'surfer_paused':
                case 'surfer:paused':
                    setSurferMatchState(prev => ({
                        ...(prev || {}),
                        phase: 'paused'
                    }));
                    setActiveComponent(51.1);
                    break;

                case 'surfer_match_resumed':
                case 'surfer_resumed':
                case 'surfer:resumed':
                    setSurferMatchState(prev => ({
                        ...(prev || {}),
                        phase: 'running'
                    }));
                    setActiveComponent(51.1);
                    break;

                case 'surfer_match_finished':
                case 'surfer_finished':
                case 'surfer_game_over':
                case 'surfer:finished':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'finished',
                            winnerSide: incoming.winnerSide || incoming.winner || prev?.winnerSide,
                            winReason: incoming.winReason || prev?.winReason
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_match_reset':
                case 'surfer_game_reset':
                case 'surfer_reset':
                case 'surfer:reset':
                    setLottery(null); setQuestion(null); setResults(null);
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming,
                            phase: 'game_ready',
                            winnerSide: null,
                            player1: {
                                ...(prev?.player1 || {}),
                                score: 0,
                                hits: 0,
                                coinsCollected: 0,
                                bonusesCollected: 0,
                                currentLane: 1
                            },
                            player2: {
                                ...(prev?.player2 || {}),
                                score: 0,
                                hits: 0,
                                coinsCollected: 0,
                                bonusesCollected: 0,
                                currentLane: 1
                            }
                        };
                    });
                    setActiveComponent(51.1);
                    break;

                case 'surfer_player_joined':
                case 'surfer_player_disconnected':
                    setSurferMatchState(prev => {
                        const incoming = message.payload || message.data || {};
                        return {
                            ...(prev || {}),
                            ...incoming
                        };
                    });
                    break;

                default:
                    console.log('Unknown:', message.type)
                    break
            }
        }

        connect()
        document.body.classList.add('customBg')

        return () => {
            if (countdownTimerRef.current) clearTimeout(countdownTimerRef.current);
        }
    }, [])

    useEffect(() => {
        return () => {
            const searchParams = new URLSearchParams(window.location.search);
            if (!propRoomId && !searchParams.get('roomId')) {
                ClearSocketMessageHandler()
                DisconnectWebSocket()
            }
        }
    }, [propRoomId])

    useEffect(() => {
        if (!defaultView) return;
        const norm = defaultView.toLowerCase();
        if (norm === 'wait') {
            setActiveComponent(1);
        } else if (norm === 'welcome') {
            setActiveComponent(9);
        } else if (norm === 'start') {
            setActiveComponent(7);
        } else if (norm === 'thanks') {
            setActiveComponent(8);
        } else if (norm === 'fighters_cover' || norm === 'fighterscover') {
            setActiveComponent(42);
        } else if (norm === 'fighters' || norm === 'fightersgame' || norm === 'fighters_game') {
            setActiveComponent(42.1);
        } else if (norm === 'quickreaction_cover' || norm === 'quickreactioncover') {
            setActiveComponent(43);
        } else if (norm === 'quickreaction' || norm === 'quickreaction_game' || norm === 'quickreactiongame' || norm === 'reaccionrapida') {
            setActiveComponent(43.1);
        } else if (norm === 'playlist' || norm === 'armalaplaylist') {
            setActiveComponent(45);
        } else if (norm === 'memory_cover' || norm === 'memorycover' || norm === 'memorama_cover' || norm === 'memoramacover' || norm === 'frontpagememory') {
            setActiveComponent(46);
        } else if (norm === 'memory' || norm === 'memorygame' || norm === 'memorama' || norm === 'memory_game' || norm === 'memoryscreen') {
            setActiveComponent(46.1);
        } else if (norm === 'sequence_cover' || norm === 'sequencecover' || norm === 'sequence_frontpage' || norm === 'sequencefrontpage' || norm === 'frontpagesequence') {
            setActiveComponent(48);
        } else if (norm === 'sequence' || norm === 'sequencescreen' || norm === 'secuencia' || norm === 'sequence_screen') {
            setActiveComponent(48.1);
        } else if (norm === 'tugofwar_cover' || norm === 'tugofwarcover' || norm === 'tug_of_war_cover' || norm === 'estirayaflojacover') {
            setActiveComponent(47);
        } else if (norm === 'tugofwar' || norm === 'tugofwargame' || norm === 'tugofwar_game' || norm === 'tug_of_war' || norm === 'estirayafloja') {
            setActiveComponent(47.1);
        } else if (norm === 'surfer_cover' || norm === 'surfercover' || norm === 'esquivador_cover' || norm === 'esquivadorcover') {
            setActiveComponent(51);
        } else if (norm === 'surfer' || norm === 'surfer_game' || norm === 'surfergame' || norm === 'surfer_screen' || norm === 'surferscreen' || norm === 'esquivador' || norm === 'esquivadorgame') {
            setActiveComponent(51.1);
        } else if (norm === 'personalsurfer' || norm === 'personal_surfer' || norm === 'esquivador' || norm === 'surfer') {
            setActiveComponent(52);
        }
    }, [defaultView]);

    return (
        <>
            {activeComponent === 1 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 2 && (<Questions question={question} />)}
            {activeComponent === 3 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 3.1 && (<Results payload={results} />)}
            {activeComponent === 4 && (<Wait isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 4.1 && (<Lottery payload={lottery} />)}
            {/* {activeComponent === 5 && (<Versus isActiveWomensMode={isActiveWomensMode} />)} */}
            {/* {activeComponent === 5.1 && (<GoalScreen state={goal} />)} */}
            {activeComponent === 5.2 && (<GoalScreenV2 currentMatchState={goal} />)}
            {activeComponent === 5.3 && (<FrontPageRunToGoal isActiveWomensMode={isActiveWomensMode} currentMatchState={goal} />)}
            {activeComponent === 6 && (<Colors />)}
            {activeComponent === 6.1 && (<Colors />)}
            {activeComponent === 7 && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {/* {activeComponent === 7 && (<QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} />)} */}
            {activeComponent === 8 && (<Thanks isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 9 && (<Welcome isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 10 && (<RojitoBrandFrontPage isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 10.1 && (<RojitoBrandBalloons state={balloons} ui={balloonsUI} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 11 && (<RiddleFrontPage isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 11.1 && (<Riddle riddle={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 12 && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {/* {activeComponent === 12 && (<QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} />)} */}
            {activeComponent === 12.1 && (<SelfieFan selfieFan={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 13 && (<QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 14 && (<SelfieFanIA selfieFan={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 15 && (<FrontPage data={question} />)}
            {activeComponent === 15.1 && (<QuizzWithImageAndOptions quizz={question} />)}
            {activeComponent === 16 && (<FrontPageNoisemeterV2 isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 16.1 && (<NoisemeterV2 data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 17 && (<QRMessages data={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 18 && (<QRPluckingRooster data={question} customConfig={question?.customConfig || question || bootstrapConfigRef.current} roomId={propRoomId || new URLSearchParams(window.location.search).get('roomId')} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 19 && (<RankingPluckingRooster data={question} customConfig={question?.customConfig || question || bootstrapConfigRef.current} roomId={propRoomId || new URLSearchParams(window.location.search).get('roomId')} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 20 && (<FrontPageLuchoFest isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 20.1 && (<LuchoFest question={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 21 && (<FrontPagePicnic isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 21.1 && (<Picnic matchResults={question} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 22 && (<FrontPageBriefcase />)}
            {activeComponent === 22.1 && (<BriefcaseScreen currentGameState={briefcaseState} />)}
            {activeComponent === 23 && (<FrontPageTacos customConfig={tacoMatchState?.customConfig} />)}
            {activeComponent === 23.1 && (<Tacos currentGameState={tacoMatchState} />)}
            {activeComponent === 24 && (<CatchTheBall incomingData={catchMatchState} />)}
            {activeComponent === 25 && ( <SlotMachine screenId={1} isStandalone={false} payload={slotPayload} /> )}
            {activeComponent === 26 && (<Voting payload={question} results={null} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 26.1 && (<Voting payload={null} results={results} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 26.1 && (<Voting payload={null} results={results} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 27 && (<FrontpageCaps isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 27.1 && (<Caps currentGameState={capsMatchState} isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 28 && (<Roulette screenId={1} isStandalone={false} payload={roulettePayload} />)}
            {activeComponent === 29 && (<LightShow isActiveWomensMode={isActiveWomensMode} />)}
            {activeComponent === 30 && (<CarreraContinuaCover theme={carreraMatchState?.theme || carreraMatchState} config={carreraMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 30.1 && (<CarreraContinuaGame currentMatchState={carreraMatchState} theme={carreraMatchState?.theme || carreraMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 42 && (<FightersCover theme={fightersMatchState?.theme || fightersMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 42.1 && (<FightersGame currentMatchState={fightersMatchState} theme={fightersMatchState?.theme || fightersMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 43 && (<QuickReactionCover theme={quickReactionMatchState?.theme || quickReactionMatchState} config={quickReactionMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 43.1 && (<QuickReactionGame currentMatchState={quickReactionMatchState} theme={quickReactionMatchState?.theme || quickReactionMatchState} config={quickReactionMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 45 && (<PlaylistScreen roomId={propRoomId} />)}
            {activeComponent === 46 && (<MemoryCover theme={memoryMatchState?.theme || memoryMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 46.1 && (<MemoryGame currentMatchState={memoryMatchState} payload={memoryMatchState} theme={memoryMatchState?.theme || memoryMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 47 && (<TugOfWarCover theme={tugOfWarMatchState?.theme || tugOfWarMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 47.1 && (<TugOfWarGame currentMatchState={tugOfWarMatchState} theme={tugOfWarMatchState?.theme || tugOfWarMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 48 && (<FrontPageSequence />)}
            {activeComponent === 48.1 && (<SequenceScreen screenId={1} isStandalone={false} payload={sequencePayload} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 51 && (<SurferCover theme={surferMatchState?.theme || surferMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 51.1 && (<SurferGame currentMatchState={surferMatchState} theme={surferMatchState?.theme || surferMatchState} roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {activeComponent === 52 && (<PersonalSurferOverlay roomId={propRoomId || (typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('roomId') : null)} />)}
            {!activeComponent && (<Start isActiveWomensMode={isActiveWomensMode} />)}
            {/* {!activeComponent && (<QRSelfieFan data={question} isActiveWomensMode={isActiveWomensMode} />)} */}
            
            {toastMessage && (
                <div className="toast-container position-fixed bottom-0 start-50 translate-middle-x mb-3">
                    <div className="toast show bg-success text-white px-3 py-2 shadow rounded">
                        {toastMessage}
                    </div>
                </div>
            )}
        </>
    )
}

export { Screen };